import styled from 'styled-components';

// Styled Components
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 88px);
`;

export const HeaderWithActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
  padding-bottom: 8px;
  flex-shrink: 0;
`;

export const TabsContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const TotalAndButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const TotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 120px;
  white-space: nowrap;
`;

export const TotalWithDiff = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HeaderContainer = styled.div`
  padding: 8px 24px;
`;

export const getTabStyles = (theme, index) => ({
  font: theme.fonts.textSmallWeight600Height16,
  color: theme.colors.greys.darker,
  minWidth: index === 1 ? '188px' : '64px',

  '&.Mui-selected': {
    color: theme.colors.greys.darkest,
    font: theme.fonts.textSmallWeight700Height16Bold,
  },
});
